import { useLanguage } from '@/contexts/LanguageContext';
import { GameState } from '@/game/useTetris';

interface GameOverlayProps {
  gameState: GameState;
  score: number;
  onStart: () => void;
}

export function GameOverlay({ gameState, score, onStart }: GameOverlayProps) {
  const { t } = useLanguage();
  if (gameState === 'playing') return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-background/70 backdrop-blur-sm rounded-xl z-10">
      <div className="text-center p-6">
        {gameState === 'idle' && (
          <>
            <h2 className="text-3xl font-bold gradient-text mb-2">{t.game.title}</h2>
            <p className="text-muted-foreground mb-1 text-sm">{t.game.playAndWin}</p>
            <p className="text-xs text-muted-foreground mb-6">{t.game.breakRecord}</p>
            <button onClick={onStart} className="btn-gradient">
              {t.game.start}
            </button>
            
          </>
        )}
        {gameState === 'paused' && (
          <>
            <h2 className="text-2xl font-bold text-foreground mb-4">{t.game.paused}</h2>
            <p className="text-sm text-muted-foreground">{t.game.pauseHint}</p>
          </>
        )}
        {gameState === 'gameover' && (
          <>
            <h2 className="text-2xl font-bold text-destructive mb-2">{t.game.gameOver}</h2>
            <p className="text-3xl font-extrabold text-foreground mb-4">{score.toLocaleString()} p</p>
            <button onClick={onStart} className="btn-gradient">
              {t.game.restart}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
